import React from "react";
import { Col, Grid, Glyphicon } from "react-bootstrap";
import paypal from "paypal-checkout";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { recordPayment } from "../../../actions/basket";
import currencySymbols from "../../../utils/currencySymbols";
import "./styles.css";
const PayPalButton = paypal.Button.driver("react", { React, ReactDOM });

class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { proceesingPayment: false };
  }

  render() {
    const paypalVersion = localStorage.getItem("ppv");
    const savePayment = transactionId => {
      const obj = {
        method: "paypal",
        currency: this.props.money.currency[0],
        amount: this.props.money.totalToPay,
        result: true,
        error: "",
        correlation: "",
        transaction: transactionId,
        paymentRef: this.props.paymentRef
      };
      this.props.recordPayment(this.props.basketId, obj).then(() => {
        this.setState({ proceesingPayment: false });
      });
    };
    const onSuccess = (data, actions) => {
      this.setState({ proceesingPayment: true });
      return actions.payment.execute().then(function(payment) {
        // The payment is complete!
        // You can now show a confirmation message to the customer
        let transactionId =
          payment.transactions.length > 0 &&
          payment.transactions[0].related_resources.length > 0
            ? payment.transactions[0].related_resources[0].sale.id
            : "";
        let isString =
          typeof transactionId === "string" || transactionId instanceof String;
        if (isString && transactionId.length <= 24) {
          savePayment(transactionId);
        }
      });
    };

    const onError = err => {
      // The main Paypal's script cannot be loaded or somethings block the loading of that script!
      const obj = {
        method: "paypal",
        currency: this.props.money.currency[0],
        amount: this.props.money.totalToPay,
        result: false,
        error: err.message,
        correlation: "blah",
        transaction: "blah",
        paymentRef: this.props.paymentRef
      };
      this.props.recordPayment(this.props.basketId, obj);
    };

    const payment = (data, actions) => {
      return actions.payment.create({
        payment: {
          intent: "sale",
          transactions: [
            {
              amount: {
                total: (this.props.money.totalToPay / 100)
                  .toFixed(2)
                  .toString(),
                currency: this.props.money.currency[0]
              },
              description: "Ski Lifts Transfer",
              custom: this.props.bookingId
            }
          ],
          note_to_payer: "Contact us for any questions on your order."
        }
      });
    };

    let env = process.env.REACT_APP_PAYPAL_ENV; // you can set here to 'production' for production

    const client = {
      sandbox: process.env.REACT_APP_PAYPAL_SANBOX_KEY,
      production: process.env.REACT_APP_PAYPAL_PRODUCTION_KEY
    };
    let LoadPayPalv1 = () => {
      if (!this.props.recordPaymentSuccess) {
        return (
          <div className="paypal-button">
            <PayPalButton
              env={env}
              locale="en_GB"
              onError={err => onError(err)}
              payment={(data, action) => payment(data, action)}
              onAuthorize={(data, action) => onSuccess(data, action)}
              client={client}
              style={{
                size: "responsive",
                color: "silver",
                shape: "rect",
                label: "checkout",
                tagline: false
              }}
            />
          </div>
        );
      }
    };

    setTimeout(() => {
      window.history.replaceState(
        null,
        "Airport Transfers to Ski Resorts | Ski-Lifts",
        "/payment-page"
      );
    }, 3000);

    return (
      <div>
        {paypalVersion !== "2" && this.state.proceesingPayment ? (
          <div className="spinner">
            {" "}
            <i className="fa fa-circle-o-notch fa-spin fa-5x fa-fw" />
          </div>
        ) : null}

        <Grid className="banner">
          <Col xs={12} sm={7} lg={9}>
            <Col>
              <h1>
                <strong>Payment</strong>
              </h1>
            </Col>

            {paypalVersion !== "2" ? (
              <div>
                {" "}
                <div className="amount">
                  <Col>
                    <h3>
                      <strong>Your Total:</strong>{" "}
                      {currencySymbols[this.props.money.currency[0]]}
                      {(this.props.money.totalToPay / 100).toFixed(2)}
                    </h3>
                  </Col>
                  <Col style={{ marginTop: "20px", display: "flex" }}>
                    {localStorage.getItem("converted") === "true" && LoadPayPalv1()}
                  </Col>
                </div>
                <Col xs={12} className="bottom-image">
                  <h4>Or enter your card payment details below:</h4>
                </Col>
              </div>
            ) : null}
          </Col>
          <Col xs={12} sm={5} lg={3} className="text-center">
            <div className="contact-note text-left">
              <div>
                <Glyphicon glyph="earphone" />
                <a href="tel:44-20-8819-7950">
                  <strong>UK: </strong>+44 (0) 20 8819 7950
                </a>
              </div>
              <div>
                <Glyphicon glyph="earphone" />
                <a href="tel:33-20-481-680-864">
                  <strong>International: </strong>+33 (0) 481 680 864
                </a>
              </div>
              <h5 style={{ color: "#666666" }}>
                <strong>We're open 9 - 5.30pm GMT</strong>
              </h5>
            </div>
          </Col>
        </Grid>
      </div>
    );
  }
}

export default connect(
  state => ({
    recordPaymentSuccess: state.payment.recordPayment.recordPaymentSuccess
  }),
  { recordPayment }
)(Payment);



// WEBPACK FOOTER //
// ./src/containers/PaymentPage/Banner/index.js